<script lang="ts" setup>
import type { GiftSuggestion } from '@consumer/types/serializers'
import { faStar } from '@fortawesome/pro-solid-svg-icons'
import { pluralize } from 'inflection'

withDefaults(defineProps<{
  giftSuggestion: GiftSuggestion
  gaTrackName?: string
}>(), {  })
</script>
<template>
  <a
    style="width: 200px;"
    class="p-3 rounded-v2sm border-1 border-solid border-grey-primary h-full flex flex-col gap-2 bg-whit
    shadow-v2md"
    :href="giftSuggestion.url"
    :data-track-ga="gaTrackName"
  >
    <div class="w-full">
      <GiftlyV3Image :gift="giftSuggestion" class="w-full h-full object-cover"/>
    </div>

    <div class="flex-1 text-[12px] flex flex-col gap-2 justify-between leading-3">
      <div class="flex flex-col gap-2">
        <div class="font-semibold">
          {{ giftSuggestion.title }}
        </div>

        <div class="text-v2-secondary">
          <template v-if="giftSuggestion.type === 'business'">
            {{ giftSuggestion.address }}
          </template>
          <template v-else>
            {{ giftSuggestion.businessCount }}
            {{ (giftSuggestion.businessCount ?? 0) > 1 ? pluralize('business') : 'business' }}
          </template>
        </div>
      </div>

      <div class="text-navy">
        <span v-if="giftSuggestion.rating">
          <GIcon :icon="faStar" class="h-[12px] w-[12px]"/>
          {{ giftSuggestion.rating }}
          ({{ giftSuggestion.reviewCountDisplay }})
          &bull;
        </span>
        {{
          [
            giftSuggestion.price,
            giftSuggestion.categories?.join(', ')
          ].filter(Boolean).join(' &bull; ')
        }}
      </div>
    </div>
  </a>
</template>
